import { render, staticRenderFns } from "./DocumentTable.vue?vue&type=template&id=26e6f3be&"
import script from "./DocumentTable.vue?vue&type=script&lang=ts&"
export * from "./DocumentTable.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentTable.vue?vue&type=style&index=0&id=26e6f3be&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26e6f3be')) {
      api.createRecord('26e6f3be', component.options)
    } else {
      api.reload('26e6f3be', component.options)
    }
    module.hot.accept("./DocumentTable.vue?vue&type=template&id=26e6f3be&", function () {
      api.rerender('26e6f3be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_Document/DocumentTable.vue"
export default component.exports